
import Vue from 'vue'
import { profile } from '@/utils/mapping'

const mutations = {
  setUserProfile(state, payload) {
    state.user = {
      ...state.user,
      ...payload
    }
  },
  setUserFormErrors(state, errors) {
    Vue.set(this.state.myAgency, 'userFormErrors', errors.map(item => profile.formErrors(item)))
  },
  setAgencyProfile(state, payload) {
    state.agency = {
      ...state.agency,
      ...payload
    }
  }
}

export default mutations